
/* eslint-disable react/prop-types */
const ModalGeneric = ({ isVisible, onClose, children }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/70 px-3 pb-6 pt-24 sm:px-4 sm:pt-28 md:pt-32">
      <div className="relative w-full max-w-2xl overflow-hidden rounded-[2rem] border border-zinc-800 bg-gradient-to-b from-zinc-900 via-zinc-900 to-zinc-950 p-5 shadow-[0_18px_50px_rgba(0,0,0,0.28)] sm:p-6">
        <button
          onClick={onClose}
          className="absolute right-2 top-2 z-10 grid h-10 w-10 place-items-center rounded-full border border-zinc-700 bg-zinc-950/80 text-zinc-300 transition-colors hover:border-zinc-500 hover:bg-zinc-900 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/20"
          aria-label="Cerrar modal"
        >
          ×
        </button>
        <div className="pt-11">{children}</div>
      </div>
    </div>
  );
};

export default ModalGeneric;
